// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    PROMO_BANNER_LOADING() {
      return {
        isLoading: true,
        promoBanner: action.promoBanner
      };
    },
    PROMO_BANNER_LOADED() {
      return {
        isLoading: false,
        data: action.promoBanner
      };
    },
    PROMO_BANNER_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.promoBanner.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
